/**
 * O 1.x aceitava `isAuditor` como boolean, string "true" ou 1 — documentos antigos foram
 * gravados de formas diferentes. Mantido para não deslogar quem tem perfil legado.
 */
function flagLigada(valor) {
    if (valor === true || valor === 1)
        return true;
    return typeof valor === 'string' && valor.toLowerCase() === 'true';
}
export function papelDe(perfil) {
    if (!perfil)
        return 'comum';
    if (flagLigada(perfil.isMaster))
        return 'master';
    if (flagLigada(perfil.isAdmin))
        return 'admin';
    if (flagLigada(perfil.isAuditor))
        return 'auditor';
    return 'comum';
}
export const ROTULO_PAPEL = {
    master: 'Master',
    admin: 'Administrador',
    auditor: 'Auditor',
    comum: 'Contagem',
};
export function permissoesDe(papel) {
    const admin = papel === 'admin' || papel === 'master';
    return {
        contar: true,
        gerenciarProdutos: admin,
        gerenciarEstoque: admin,
        verAuditoria: admin || papel === 'auditor',
        corrigirContagem: admin,
        // Decisão do produto na 4.19.7: qualquer usuário fecha a contagem, protegido pela
        // confirmação de digitar FINALIZAR — o funcionário que contou é quem sabe que acabou.
        finalizarContagem: true,
        gerenciarUsuarios: papel === 'master',
        verHistorico: papel === 'master',
        // Auditor vê: o trabalho dele é justamente comparar contagem com sistema.
        verEstoqueSistema: admin || papel === 'auditor',
    };
}
//# sourceMappingURL=papeis.js.map